import { render, staticRenderFns } from "./compareHaji.vue?vue&type=template&id=1484cb96&"
import script from "./compareHaji.vue?vue&type=script&lang=ts&"
export * from "./compareHaji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports